import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

// Standardized, compact page-level header for admin/config pages. Renders a title
// (+ optional subhead) with a themed background/border so it doesn't float directly on
// the raw page background, plus an optional right-aligned action slot (buttons, toggles, etc.)
// This is intentionally lighter-weight than <Panel />, which is meant for real collapsible/
// refreshable content sections, not a one-line page title strip.
// Usage: place as the first <Row> child inside the page's existing <Container>.
export default function PageHeader({
  title, subhead, actions, children,
}) {
  return (
    <Col md={12}>
      <div className="page-header">
        <Row className="align-items-center">
          <Col>
            <h3 className="page-header__title">{title}</h3>
            {subhead && <h4 className="page-header__subhead">{subhead}</h4>}
            {children}
          </Col>
          {actions && (
            <Col xs="auto" className="page-header__actions">
              {actions}
            </Col>
          )}
        </Row>
      </div>
    </Col>
  );
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subhead: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
};

PageHeader.defaultProps = {
  subhead: null,
  actions: null,
  children: null,
};
